import { render, staticRenderFns } from "./Report_debtor_detail.vue?vue&type=template&id=47b5cd18&scoped=true&"
import script from "./Report_debtor_detail.vue?vue&type=script&lang=js&"
export * from "./Report_debtor_detail.vue?vue&type=script&lang=js&"
import style0 from "./Report_debtor_detail.vue?vue&type=style&index=0&id=47b5cd18&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47b5cd18",
  null
  
)

export default component.exports